module.exports = __webpack_public_path__ + "df02fd1faf78b9c02322cbfb15b6b77b.jpg";